import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	starred: {
		id: 'navigation-apps-sidebar-nav4-starred.starred',
		defaultMessage: 'Starred',
		description: 'Message for starred nav menu item in the sidebar',
	},
});
